export const selectAdditionalProductsToolsState = state => state.additionalProductsTools

export const selectAdditionalProductsToolsDerived = state => {
  const s = selectAdditionalProductsToolsState(state)
  return s
}
